
import { createAsyncThunk } from "@reduxjs/toolkit";
import { PrivateAxios } from "../../apiEcommerce";

export const payOrder = createAsyncThunk(
  "payment/payOrder",
  async ({ eco_order_id, type, device = "web" }, { rejectWithValue }) => {
    try {
      const formData = new FormData();

      formData.append("eco_order_id", String(eco_order_id));
      formData.append("type", type);
      formData.append("device", device);

      const response = await PrivateAxios.post(
        "/api/ecomerce/payment/pay",
        formData
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || "Failed to start payment"
      );
    }
  }
);
